//global filters
const filters = {
    // 清空字符串内的数字信息
    replaceNumber: val => {
        return val.replace(/(\d+(\.\d+)?(,\d+)?)/, "");
    },
    // ele phone check
    eleCheckPhone: (rule, value, callback) => {
        if (!value) {
            return callback(new Error('手机号不能为空'));
        } else {
            const reg = /^[1][3-9]\d{9}$/;
            if (reg.test(value)) {
                callback();
            } else {
                return callback(new Error('请输入正确的手机号'));
            }
        }
    },
    // 检测昵称 1-20位汉字/字母/数字或其任意组合
    checkNickName: val => {
        const reg = /^[a-zA-Z0-9\u4e00-\u9fa5]{1,20}$/;
        return reg.test(val);
    },
    // common phone check
    checkPhone: value => {
        if (!value) return false;
        return /^[1][3-9]\d{9}$/.test(value);
    },
    // common tel check
    checkTel: value => {
        if (!value) return false;
        return /^\d{3,4}\-\d{7,14}$/.test(value);
    },
    // 去掉厨卫信息
    replaceKS: val => {
        if (!val) return '';
        return val.replace(/(\d+卫)/, "").replace(/(\d+厨)/, '');
    },
    // 清空字符串内的文字信息
    parseFloat: val => {
        // 4,234 带 ， 的数字不做 parseFloat 处理
        if (/^\d+,\d+$/.test(val)) {
            return val;
        }
        return parseFloat(val.replace(/([万亿])/, ""));
    },
    // 格式化数字，如果小数点后带零，把0去掉，否则保留小数点
    removeLastZero: val => {
        // 如果不是数字 或者 小数 直接返回
        if (!/(\d+(\.\d+)?)/.test(val)){
            return val;
        }
        let _intNum = parseInt(val);
        return _intNum == val ? _intNum : val;
    },
    // 日期格式化, 返回 X年X月X日 addZero 表示是否月份不满10月要追加0， 默认不追加
    dateFormat: (val, addZero = false, unit = ['年', '月', '日'], reg = /(\d{4})[-/](\d{1,2})[-/](\d{1,2})/) => {
        let match = val.match(reg);
        //未匹配成功返回原数值
        if (!match) return val;
        let [, year, month, day] = match;
        let [yUnit, mUnit, dUnit] = unit;
        if (addZero) {
            if(month < 10) {
                month = `0${month}`;
            }
            if(day < 10) {
                day = `0${day}`;
            }
        }
        return `${year}${yUnit}${month}${mUnit}${day}${dUnit}`;
    },
    // 电话格式化
    telFormat: val => {
        if (!val) return  '';
        return val.replace(/(\d{3})(\d{4})(\d{4})/, "$1****$3");
    },
    // 切割字符串
    splitString: (str, len, remain = '…') => {
        if(!str || (str && str.length < len)) return str;
        return str.substr(0, len) + remain;
    },
    // 格式化价格
    mixPrice: (price, flag) => {
        if (!price) return 0;
        price = price * 1;
        let result, match, unit = '';
        let _price1 = filters.formatPrice(price);
        if (match = _price1.toString().match(/[万亿]/)) {
            unit = match[0];
        }
        let _price2 = _price1.toString().replace(unit, '') * 1;
        if(flag == 1){
            if (!unit) _price2 = Math.round(_price2);
        }else if(flag == 2){
            if (unit == '万') _price2 = Math.round(_price2);
        }
        if (_price2 >= 1000) {
            result = filters.thousandPrice(_price2) + unit;
        } else {
            result =  _price2 + unit;
        }
        return result;
    },
    // 格式化价格信息带单位 并且 分拆成 数字 和 单位返回
    splitMixPrice: (price) => {
        if (!price) return 0;
        price = price * 1;
        let value, match, unit = '';
        let _price1 = filters.formatPrice(price);
        if (match = _price1.match(/[万亿]/)) {
            unit = match[0];
        }
        let _price2 = _price1.toString().replace(unit, '') * 1;
        if (_price2 >= 1000) {
            value = filters.thousandPrice(_price2);
        } else {
            value = _price2;
        }
        return {value, unit};
    },
    // 千分位 格式化 价格信息
    thousandPrice: (price) => {
        if(!price) return 0;
        return price.toString().replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, '$1,');
    },
    formatPrice: (price) => {
        if (!price) return 0;
        price = price*1;
        if(price >= 10000*10000){
            return filters.formatFour(price / 100000000) + '亿';
        } else if(price >= 10000){
            return filters.formatFour(price/10000) + '万';
        } else {
            return filters.formatFour(price);
        }
    },
    // 四位数原则
    formatFour: (num) => {
        if (!num) return num;
        let price = num;
        if(num.toString().length > 4){
            if (num >= 100) {
                price = Math.round(num);
            } else if (num >= 10) {
                price =  Math.round(num * 10)/10;
            }else{
                price = Math.round(num * 100)/100;
            }
        }
        if (price.toString().length == 1){
            price = price.toString() + '.00';
        }else if(price.toString().length == 2){
            price = price.toString() + '.0';
        }else if(price.toString().length == 3){
            if(price < 10){
                price = price.toString() + '0';
            }
        }
        return price;
    }
}

// register to vue  filter
for(let key in filters) {
    Vue.filter(key, filters[key])
}


// WEBPACK FOOTER //
// ./src/assets/js/filters.js